import create from 'zustand';

const [useApplicationStore, apiApplicationStore] = create(set => ({
	rootLoading: true,
	setRootLoading: bool => set({ rootLoading: bool }),
	redirect: false,
	showSidebar: false,
	setShowSidebar: bool => set({ showSidebar: bool })
}));

export default useApplicationStore;
export { apiApplicationStore };
